import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import TaskOrdersPage from "@/pages/admin/TaskOrdersPage";

export const Route = createFileRoute("/_admin/admin/task-orders")({
  head: () => pageHead("Admin · Task Orders", "AKIVA admin · task orders portal.", "/admin/task-orders", true),
  component: TaskOrdersPage,
});
